import React, { useState } from "react";
import { Link } from "react-router-dom";
import { trimStringSmall,trimStringExtraSmall } from "../helpers/helperFunctions";

const authMenu = [
  {
    name: "My Account",
    url: "/profile",
    icon: "uil-apps icon__1",
  },
  {
    name: "My Orders",
    url: "/orders",
    icon: "uil-box icon__1",
  },
  {
    name: "My Wishlist",
    url: "/wishlists",
    icon: "uil-heart icon__1",
  },
  // {
  //   name: "My Wallet",
  //   url: "/my-wallet",
  //   icon: "uil-usd-circle icon__1",
  // },
  // {
  //   name: "My Address",
  //   url: "/my-address",
  //   icon: "uil-location-point icon__1",
  // },
  // {
  //   name: "Offers",
  //   url: "/my-offers",
  //   icon: "uil-gift icon__1",
  // },
  // {
  //   name: "Faq",
  //   url: "/faq",
  //   icon: "uil-info-circle icon__1",
  // },
  {
    name: "Logout",
    url: "/logout",
    icon: "uil-lock-alt icon__1",
  },
];
const unAuthMenu = [
  {
    name: "Login",
    url: "/login",
    icon: "uil-lock-alt icon__1",
  },
  {
    name: "Register",
    url: "/register",
    icon: "uil-lock-alt icon__1",
  },
  // {
  //   name: "Faq",
  //   url: "/faq",
  //   icon: "uil-info-circle icon__1",
  // },
];
const guestMenu = [
  {
    name: "Logout",
    url: "/logout",
    icon: "uil-lock-alt icon__1",
  },
  // {
  //   name: "Faq",
  //   url: "/faq",
  //   icon: "uil-info-circle icon__1",
  // },
];

const HeaderUserDropDown = ({ isLoggedIn, userName, isGuest }) => {
  const [userMenuExpand, setUserMenuExpand] = useState(false);

  const renderMenuItems = () => {
    if (isLoggedIn && !isGuest) {
      return authMenu.map(({ name, url, icon }) => (
        <Link key={name} to={url} className='item channel_item'>
          <i className={`uil ${icon}`}></i>
          {name}
        </Link>
      ));
    }
    if (isLoggedIn && isGuest) {
      return guestMenu.map(({ name, url, icon }) => (
        <Link key={name} to={url} className='item channel_item'>
          <i className={`uil ${icon}`}></i>
          {name}
        </Link>
      ));
    }

    return unAuthMenu.map(({ name, url, icon }) => (
      <Link key={name} to={url} className='item channel_item'>
        <i className={`uil ${icon}`}></i>
        {name}
      </Link>
    ));
  };

  return (
    <li
      className={userMenuExpand ? "ui dropdown active visible" : "ui dropdown"}
      onMouseOver={() => setUserMenuExpand(true)}
      onMouseLeave={() => setUserMenuExpand(false)}
    >
      <Link
        to={"/"}
        onClick={(event) => event.preventDefault()}
        className='opts_account'
      >
        <i className='uil uil-lock-alt'></i>
        <span className='user__name'>{trimStringExtraSmall(userName) || "Login/Sign Up"}</span>
        <i
          className={userMenuExpand ? "uil uil-angle-up" : "uil uil-angle-down"}
        ></i>
      </Link>
      <div
        className={
          userMenuExpand
            ? "menu dropdown_account left transition visible"
            : "menu dropdown_account"
        }
        style={userMenuExpand ? { display: "block" } : { display: "none" }}
      >
        {renderMenuItems()}
      </div>
    </li>
  );
};

export default HeaderUserDropDown;
